import { useState } from 'react';

import { accountsSelectors } from 'app-components/flux/accounts';
import { localPreferences } from 'app-components/utils/core';

import * as appSelectors from 'data/app/selectors';
import { useAppSelector } from 'hooks/redux';

/** The full offline page is only for a cold start with nothing to show; once the app renders it stays mounted. */
export function useShowOfflinePage(): boolean {
  const isOffline = useAppSelector(appSelectors.getIsOffline);
  const hasHydratedData = useAppSelector((state) => Boolean(accountsSelectors.getLastSyncDate(state)));
  const canRenderApp = !isOffline || hasHydratedData;
  const [hasRenderedApp, setHasRenderedApp] = useState(canRenderApp);
  if (canRenderApp && !hasRenderedApp) setHasRenderedApp(true);

  return !hasRenderedApp && !localPreferences.getOfflineSupport();
}
